import axios from "axios";

// Assuming REACT_APP_ENV is defined in your environment variables
const appMode = process.env.REACT_APP_ENV; // local/staging/production

// Get the server host from environment variables
const serverHost = process.env.REACT_APP_SERVER_HOST;

// Attempt to read the nonce from the meta tag, or use an empty string if not found
const nonceMetaTag = document.querySelector('meta[name="api-nonce"]');
const nonce = nonceMetaTag ? nonceMetaTag.getAttribute('content') : '';

// Create headers object based on the app mode
const headers = {
	"Content-Type": "application/json",
};

// Conditionally add the nonce header if appMode does not meet the condition
if (appMode !== "local") {
	headers["X-WP-Nonce"] = nonce;
}

const apiClientConfig = {
	baseURL: serverHost,
	headers: headers,
};

// Conditionally add the _nonce parameter if appMode does not meet the condition
if (appMode !== "local") {
	apiClientConfig.params = {
		_nonce: nonce,
	};
}

const apiClient = axios.create(apiClientConfig);

// Function to fetch comments for a given year
export const fetchComments = (year, setComments) => {
	return apiClient
		.post("comments", {
			year: year,
		})
		.then((response) => {
			// Check if the response status is successful
			if (response.data.status === 1) {
				return response.data.data; // Return comments data
			} else {
				throw new Error("Failed to fetch comments"); // Throw error if status is not successful
			}
		})
		.catch((error) => {
			console.error("Error:", error); // Log error
			throw error; // Re-throw the error to handle it where the function is called
		});
};

// Function to create a new comment for a given year
export const createComment = (year) => {
	return apiClient
		.post("comments/create", {
			year: year,
		})
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error("Error:", error); // Log error
			throw error; // Re-throw the error to handle it where the function is called
		});
};

// Function to submit a copy operation based on active tab, current year, and selected parameters
export const submitCopy = (activeTab, currentYear, selected) => {
	return apiClient
		.post("copy", {
			tab: activeTab,
			current_year: currentYear,
			copy_to: selected,
		})
		.then((response) => {
			return response; // Optionally return response data
		})
		.catch((error) => {
			console.error("Error:", error); // Log error
			throw error; // Re-throw the error to handle it where the function is called
		});
};

// Function to assign a category to a comment for a given week and year
export const assignCategory = (commentId, weekNumber, selectedValue, year) => {
	return apiClient
		.post("category/assign", {
			comment_id: commentId,
			week_no: weekNumber,
			category: selectedValue,
			year: year,
		})
		.then((response) => {
			if (response.data.status === 1) {
				return response.data.data[0]; // Return assigned category data if successful
			}
		})
		.catch((error) => {
			console.error("Error assigning category:", error); // Log error
			throw error; // Re-throw the error to handle it where the function is called
		});
};

// Function to fetch arena category data asynchronously
export const fetchArenaCategoryData = async () => {
	try {
		// Fetch arena category data using Axios
		const response = await apiClient.get("categories");
		if (response.data.status === 1) {
			return {
				categories: response.data.data.categories,
				tab: response.data.data.tab,
			}; // Return category data and tab information if successful
		}
	} catch (error) {
		console.error("Error fetching arena category data:", error); // Log error
		throw error; // Re-throw the error to handle it where the function is called
	}
};

// Function to delete a comment with a given ID
export const deleteComment = async (id) => {
	try {
		const response = await apiClient.post("comments/delete", {
			id: id,
		});

		if (response.data.status === 1) {
			return true; // Indicate successful deletion
		} else {
			throw new Error("Failed to delete comment"); // Throw error if deletion failed
		}
	} catch (error) {
		console.error("Error deleting comment:", error); // Log error
		throw error; // Re-throw the error to handle it where the function is called
	}
};

// Function to update a comment with a given ID and value
export const updateComment = async (id, value) => {
	try {
		await apiClient.post("comments/update", {
			id: id,
			comment: value,
		});
	} catch (error) {
		console.error("Error updating comment:", error); // Log error
		throw error; // Re-throw the error to handle it where the function is called
	}
};
